import axios from 'axios';
import showErrorView from '@/utils/showErrorView';

const isIframed = window.self !== window.top;

export const Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel(error)) {
      window.console.log('Request canceled', error.message);
    }

    const errorResponse = error.response;
    const errorRequest = error.request;

    // Access to config, request, and response
    if (errorResponse) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Response Status:', errorResponse.status);
      console.error('Response Data:', errorResponse.data);
    } else if (errorRequest) {
      // The request was made but no response was received
      console.error('No response received. Request:', errorRequest);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Request Error:', errorRequest);
    }

    // we put as much information as possible in a single line if iframe because this message is being used
    // to show the toast on the parent app where recorder is iframed
    if (isIframed) {
      await showErrorView(
        [error.message, errorResponse?.status ?? '', (errorResponse.data as any)?.message ?? '']
          .filter(Boolean)
          .join(' - '),
        '',
      );
      // if not embed, we use the UI to show it in a prettier way splitting main message and error description
      // We don't want to block users and show an error view when their credentials have expired on admin, so we filter out the 401 code
    } else if (errorResponse?.status !== 401) {
      await showErrorView(
        [error.message, errorResponse?.status ?? ''].filter(Boolean).join(' - '),
        (errorResponse?.data as any)?.message ?? '',
      );
    }
    return Promise.reject(error);
  },
);
